module.exports = __webpack_public_path__ + "static/media/discover.3a4c51a2.png";